import { QueryHookOptions, useQuery } from '@apollo/client';
import { GET_CONNECTED_SHOPIFY } from '@frontend/applications/AffiliatesApp/queries/getConnectedShopifyQuery';
import { GetConnectedShopify } from '@frontend/applications/AffiliatesApp/queries/types/GetConnectedShopify';

type TOptions = QueryHookOptions<GetConnectedShopify>;

export const useGetConnectedShopifyQuery = (options: TOptions = {}) => useQuery<GetConnectedShopify>(GET_CONNECTED_SHOPIFY, options);
